import { TipoTramiteComisionEnergiaEnum } from "@api/api";

export class SimuladorDataModel {
  DatosLuz: SimuladorDatosLuzModel;
  DatosGas: SimuladorDatosGasModel;
  TipoTramite: TipoTramiteComisionEnergiaEnum | null;

  constructor() {
    this.DatosLuz = new SimuladorDatosLuzModel();
    this.DatosGas = new SimuladorDatosGasModel();
    this.TipoTramite = TipoTramiteComisionEnergiaEnum.CambioComercializadora;
  }
}

export class SimuladorDatosLuzModel {
  PotenciaP1: number | null = null;
  PotenciaP2: number | null = null;
  PotenciaP3: number | null = null;
  PotenciaP4: number | null = null;
  PotenciaP5: number | null = null;
  PotenciaP6: number | null = null;
  ConsumoP1: number | null = null;
  ConsumoP2: number | null = null;
  ConsumoP3: number | null = null;
  ConsumoP4: number | null = null;
  ConsumoP5: number | null = null;
  ConsumoP6: number | null = null;
}

export class SimuladorDatosGasModel {
  Consumo: number | null = null;
}